import React from 'react';
import { connect } from 'react-redux';

import { updateQueryString } from '../../redux/router/actions';

import ConfirmationModal from './ConfirmationModal';

const ConfirmationModalConnected = (props) => <ConfirmationModal {...props} />;

const mapActionsToProps = {
  updateQueryString,
};

export default connect(null, mapActionsToProps)(ConfirmationModalConnected);
